import React from 'react';
import Footer from './Footer';
import Nav from './Nav';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 ">
        <div className='p-6 '>
        <Nav/>
        </div>
      {/* Container */}
      <div className="max-w-4xl my-24 mx-auto bg-white shadow-lg rounded-lg p-6">
        {/* Heading */}
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Refund Policy
        </h1>

        {/* Content */}
        <div className="space-y-6 text-gray-700">
          <p>
            At <span className="font-semibold">Pravasa.in</span>, we strive to ensure your satisfaction with our travel services. This Refund Policy outlines the terms and conditions under which refunds are processed.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              1. Eligibility for Refunds
            </h2>
            <p>
            Members may raise any issues of dissatisfaction within 10 days of utilizing their annual stay of 7 days and 6 nights per year. A proper inquiry will be conducted, and if the request is found valid, the refund process will be initiated within 45 days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              2. Deductions/Refunds,
            </h2>
            <p>
            if approved, will be subject to deductions, including administrative charges, ASF, and GST. Additionally, cancellation policies of the respective hotel and no-show charges will apply as per the booking confirmation. Members must adhere to the terms and conditions of the concerned hotel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              3. Applicability
            </h2>
            <p>
            This refund policy applies solely to benefits availed under the Vacation Purchase Agreement. It does not cover any consideration paid towards membership fees, which shall be governed by the Vacation Purchase Agreement terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              4. Termination & Cancellation
            </h2>
            <p>
            The package remains valid until its termination date or cancellation under the provisions of the Vacation Purchase Agreement.
If maintenance payments remain unpaid for two consecutive years, the package will be deemed cancelled without prior notice.
If the agreement is cancelled within 7 days of signing, a refund may be processed after deducting an administration fee of Rs. 25,000/- and any costs incurred for nights used by the purchaser. Refunds will be processed within 90 days of receiving the cancellation request.            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              5. Modification Clause
            </h2>
            <p>
            No modifications to this refund policy shall be valid unless made in writing and duly signed by both the Member and an authorized representative of the Company.            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              6. Dispute Resolution
            </h2>
            <p>
            In case of disputes, members must first contact the central customer care team. If unresolved, the matter may be escalated to the resolution cell of the Company.
If no resolution is reached, disputes shall be resolved through arbitration, with a sole arbitrator appointed by the Company. The arbitration proceedings will take place exclusively in Delhi.
Any legal proceedings, including consumer forum cases, shall be subject to the jurisdiction of courts in Delhi only.            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              7. General Conditions
            </h2>
            <p>
            The Member acknowledges that all bookings are subject to availability.
For international holidays, a minimum prior notice of one month is required, with only one unit provided per eligibility.
           </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-600">
          <p>
          By agreeing to this policy, the Member confirms that the terms are accepted voluntarily and do not impose any undue financial burden.
            &copy; {new Date().getFullYear()} Pravasa.in. All rights reserved.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default RefundPolicy;